import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { RU_TRANSLATE } from "@/data/ru-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ru/translate";
const C = RU_TRANSLATE;

export const Route = createFileRoute("/ru/translate")({
  head: () => ({
    meta: [
      { title: ctaTitle("Сертифицированный перевод RU↔TH в Бангкоке | NYC Legal", "/ru/translate", "th")},
      { name: "description", content: ctaDesc("Переводы, признаваемые МИД, Иммиграцией, DBD и посольствами. Переводчик MOJ. 1–3 рабочих дня. Start with a free review before you file anything.", "/ru/translate", "th")},
      { property: "og:title", content: ctaTitle("Сертифицированный перевод RU↔TH | NYC Legal", "/ru/translate", "th")},
      { property: "og:description", content: ctaDesc("RU↔TH↔EN с печатью MOJ. Апостиль одним пакетом.", "/ru/translate", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ru_RU" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/translate" },
          { hreflang: "en", path: "/en/translate" },
          { hreflang: "zh", path: "/zh/translate" },
          { hreflang: "ja", path: "/ja/translate" },
          { hreflang: "ko", path: "/ko/translate" },
          { hreflang: "ru", path: "/ru/translate" },
          { hreflang: "x-default", path: "/translate" },
        ],
        "/translate",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "ProfessionalService",
        name: "NYC Legal — Certified Translation (RU)", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "RU"], inLanguage: "ru",
        priceRange: "฿500–฿3,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ru",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Главная", item: `${SEO_SITE}/ru` },
          { "@type": "ListItem", position: 2, name: "Перевод", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
